import request from '@/src/apis/axios';
import { GetContentTemplatesRequestParams } from '@/src/apis/rest/contentTemplate.dtos';
import ContentTemplateDto from '@/src/models/ContentTemplateDto';
import { ListResponse } from '@/src/types/common';
import { plainToInstance } from 'class-transformer';

const URL = {
  contentTemplates: '/content-templates',
};

// 웹뷰 마크업 템플릿 리스트 조회
export const getContentTemplatesAPI = async (
  requestParams: Partial<GetContentTemplatesRequestParams>,
) => {
  const { page = 1, pageSize = 100, ...rest } = requestParams;

  const { data } = await request<ListResponse<ContentTemplateDto>>({
    method: 'get',
    url: URL.contentTemplates,
    queryParams: { ...rest, page, pageSize },
  });

  const rows = plainToInstance(ContentTemplateDto, data.rows);

  return { rows, count: data.count };
};
